import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBack: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="back"><path fillRule="evenodd" clipRule="evenodd" d="M20 3.91309L7.08693 11.9998L20 20.0866V3.91309ZM4 3.99984V19.9998H5.5V3.99984H4ZM18.5 6.62232V17.3774L9.91307 11.9998L18.5 6.62232Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBack;
